<p8-layout-settings-header [titlePath]="['Choix de la catégorie']" [iconRacine]="'category'"></p8-layout-settings-header>

<div mat-dialog-content fxLayout="column" style="padding-top: 5px;">
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <div style="overflow-y: scroll; max-height: 250px;">
    <app-tree #treeStructures
              [nodeNameFct]="getNodeName"
              [parents]="categoryTree"
              [editMode]="false"
              (onClick)="selectNode($event)"
    >
    </app-tree>
  </div>

  <mat-form-field appearance="outline" fxFlex="80">
    <mat-label>La sélection sera affichée ici</mat-label>
    <input type="text"
           readonly
           [value]="catName"
           matInput data-cy="input-category-select-catName"/>
  </mat-form-field>
</div>

<div mat-dialog-actions fxLayoutAlign="end">

  <button mat-raised-button
          (click)="close()" data-cy="input-category-select-close">
    Annuler
  </button>
  <button mat-raised-button
          [color]="'warn'"
          [disabled]="!catId"
          (click)="save()" data-cy="input-category-select-save">
    Sélectionner
  </button>
</div>
